import { lazy } from 'react';

import { checkModule } from 'shared/utils/appModules'
import handbooks       from 'views/pages/Handbooks/SpreadSheetHandbook/configs/index'

const Map = lazy(() => import('views/pages/MapPage/MapFunc'));
const Users = lazy(() => import('views/pages/Users'));
const Roles = lazy(() => import('views/pages/Roles'));
const About = lazy(() => import('views/pages/About'));

const OnlineWatching = lazy(() => import('views/pages/Video/OnlineWatching'));
const VideoArchive = lazy(() => import('views/pages/Video/VideoArchive/'));
const VehicleArchiveMonitoring = lazy(() => import('views/pages/Video/VehicleArchiveMonitoring'));

const VehicleWorkData = lazy(() => import('views/pages/VehicleWorkData'));

const VehicleDiagnostic = lazy(() => import('views/pages/VehicleDiagnostic/VehicleDiagnostic/VehicleDiagnostic'));
const Asmpp = lazy(() => import('views/pages/VehicleDiagnostic/Asmpp'));
const EquipmentAnalysisPerfSmsv = lazy(() => import('views/pages/VehicleDiagnostic/EquipmentAnalysisPerfSmsv'))
const TemperatureSensorsAnalysis = lazy(() => import('views/pages/VehicleDiagnostic/TemperatureSensors'))

const Passage = lazy(() => import('views/pages/Passengers/PassagePage'));
const Stops = lazy(() => import('views/pages/Passengers/StopsPage'));
const StopsTurn = lazy(() => import('views/pages/Passengers/Stops'));
const BetweenStops = lazy(() => import('views/pages/Passengers/BetweenStops'));
const RollingStock = lazy(() => import('views/pages/Passengers/RollingStock'));
const RollingStockDist = lazy(() => import('views/pages/Passengers/RollingStockDist'));
const DailyData = lazy(() => import('views/pages/Passengers/DailyData'))
const PassageRegistry = lazy(() => import('views/pages/Passengers/PassageRegistry'));
const PassageAnalysis = lazy(() => import('views/pages/Passengers/PassageAnalysis'));
const PassagePay = lazy(() => import('views/pages/Passengers/PassagePay'));
const Correspondence = lazy(() => import('views/pages/Passengers/Correspondence'));
const PassTurn = lazy(() => import('views/pages/Passengers/PassTurn'));

const ReportsPage = lazy(() => import('views/pages/Reports/ReportsTrafficPage'));
const Journal = lazy(() => import('views/pages/Journal/index'));

const SpreadSheetHandbook = lazy(() => import('views/pages/Handbooks/SpreadSheetHandbook'));

const NavigationSettings = lazy(() => import('views/pages/SystemSettings/Navigation'));
const SystemVideoSettings = lazy(() => import('views/pages/SystemSettings/Video'));
const PassengersSettings = lazy(() => import('views/pages/SystemSettings/Passengers'));
const JournalsSettings = lazy(() => import('views/pages/SystemSettings/Journals'));
const BCSettings = lazy(() => import('views/pages/SystemSettings/BC'));
const EIS = lazy(() => import('views/pages/SystemSettings/EIS'));
const TemperatureSensors = lazy(() => import('views/pages/SystemSettings/TemperatureSensors'));
const AlarmSystem = lazy(() => import('views/pages/SystemSettings/AlarmSystem'));
const SMSVSettings = lazy(() => import('views/pages/SystemSettings/SMSV'));

const BCCalendar = lazy(() => import('views/pages/BCCalendar'));
const ControllerTask = lazy(() => import('views/pages/ControllerTask'));
const RouteRate = lazy(() => import('views/pages/RouteRate'));
const BCResult = lazy(() => import('views/pages/ControllerTask/BCResult'));
const DepartmentControll = lazy(() => import('views/pages/DepartmentControll'));
const BCReports = lazy(() => import('views/pages/BCReports'));
const UserBCResult = lazy(() => import('views/pages/UserBCResult'));

const ConfigurationsMNT = lazy(() => import('views/pages/RemoteUpdate/ConfigurationsMNT'));
const ConfigurationGroup = lazy(() => import('views/pages/RemoteUpdate/ConfigurationGroup'));
const VehicleGroups = lazy(() => import('views/pages/RemoteUpdate/VehicleGroups'));

const TicketsValidation = lazy(() => import('views/pages/TicketsValidation/TicketsValidation'));

const IncidentsDynamic = lazy(() => import('views/pages/Adas/IncidentsDynamic'));
const IncidentsDistribution = lazy(() => import('views/pages/Adas/IncidentsDistribution'));
const IncidentsDetailing = lazy(() => import('views/pages/Adas/IncidentsDetailing'));

const Heatmap = lazy(() => import('views/pages/PDM/Heatmap'));
const TreeEditor = lazy(() => import('views/pages/PDM/TreeEditor'));
const VehicleDiagnosticReport = lazy(() => import('views/pages/PDM/VehicleDiagnosticReport'));
const ChangeNodeJournal = lazy(() => import('views/pages/PDM/ChangeNodeJournal'));
const Charts = lazy(() => import('views/pages/PDM/Charts'));
const Service = lazy(() => import('views/pages/PDM/Service'));
const EquipmentStatusReport = lazy(() => import('views/pages/PDM/EquipmentStatusReport'));
const ImportManager = lazy(() => import('views/pages/PDM/ImportManager'));

const DrivingAssessment = lazy(() => import('views/pages/DrivingAssessment'));

const SMSV = lazy(() => import('views/pages/SMSV'));


export interface IRoute {
  title?: string,
  path: string,
  component: any,
  section?: string,
  off?: string[],
  alwaysAvailable?: boolean
}

export interface IRouteGroup {
  groupTitle?: string,
  module?: string,
  routes: IRoute[]
}

export const routesList: IRouteGroup[] = [
  {
    module: 'map',
    routes: [
      { title: 'Карта', path: '/map', component: Map },
    ],
  },
  {
    groupTitle: 'Видео',
    module:     'video',
    routes:     [
      { title: 'Видео с ТС', path: '/video/online', component: OnlineWatching, section: 'online' },
      { title: 'Архив видео', path: '/video/archive', component: VideoArchive, section: 'archive' },
      {
        title:     'Мониторинг архива на ТС',
        path:      '/video/vehicle-archive-monitoring',
        component: VehicleArchiveMonitoring,
        section:   'vehicle-archive-monitoring',
      },
    ],
  },
  {
    groupTitle: 'Пассажиропоток',
    module:     'passengers',
    routes:     [
      {
        title:     'Текущие данные',
        path:      '/passengers/analysis',
        component: PassageAnalysis,
        section:   'analysis',
      },
      {
        title:     'Реестр обследований',
        path:      '/passengers/registry',
        component: PassageRegistry,
        section:   'registry',
      },
      {
        title:     'Рейсы',
        path:      '/passengers/passage',
        component: Passage,
        section:   'passage',
      },
      {
        title:     'Остановочные пункты',
        path:      '/passengers/stops',
        component: Stops,
        section:   'stops',
      },
      {
        title:     'Оплата по рейсам',
        path:      '/passengers/pay',
        component: PassagePay,
        section:   'pay',
      },
      {
        title:     'Межостановочные/межрайонные корреспонденции',
        path:      '/passengers/correspondence',
        component: Correspondence,
        section:   'correspondence',
      },
      {
        title:     'Пассажирооборот маршрута',
        path:      '/passengers/passturn/table',
        component: PassTurn,
        section:   'passturn',
      },
      {
        title:     'Пассажирооборот ОП',
        path:      '/passengers/turnstops/table',
        component: StopsTurn,
        section:   'turnstops',
      },
      {
        title:     'Нагрузка на ТС на перегонах',
        path:      '/passengers/betweenstops/table',
        component: BetweenStops,
        section:   'betweenstops',
      },
      {
        title:     'Потребное количество подвижного состава',
        path:      '/passengers/rolling-stock',
        component: RollingStock,
        section:   'rolling-stock',
      },
      {
        title:     'Перераспределение подвижного состава',
        path:      '/passengers/dist-rolling-stock',
        component: RollingStockDist,
        section:   'dist-rolling-stock',
      },
      {
        title:     'Отчёты по пассажиропотоку',
        path:      '/reports/traffic',
        component: ReportsPage,
        section:   'reports',
      },
      {
        title:     'Ежедневные данные (new)',
        path:      '/passengers/daily-data',
        component: DailyData,
        section:   'daily-data',
      },
    ],
  },
  {
    groupTitle: 'Проведение билетного контроля',
    module:     'bc',
    routes:     [
      {
        title:     'Производственный календарь',
        path:      '/bc/calendar',
        component: BCCalendar,
        section:   'calendar',
      },
      {
        title:     'Наряд-задания',
        path:      '/bc/controllertask',
        component: ControllerTask,
        section:   'controllertask',
      },
      {
        title:     'Рейтинги маршрутов',
        path:      '/bc/routerate',
        component: RouteRate,
        section:   'routerate',
      },
      {
        title:     'Текущий процесс контроля',
        path:      '/bc/departmentcontroll',
        component: DepartmentControll,
        section:   'departmentcontroll',
      },
      {
        title:     'Результаты ПБК',
        path:      '/bc/resultuser',
        component: UserBCResult,
        section:   'resultuser',
      },
      {
        title:     'Отчеты по ПБК',
        path:      '/bc/reports',
        component: BCReports,
        section:   'reports',
      },
      {
        path:      '/bc/result/:task',
        component: BCResult,
        section:   'reports',
      },
      {
        path:      '/bc/resultuser/:task',
        component: BCResult,
        section:   'resultuser',
      },
    ],
  },
  {
    groupTitle: 'Импорт данных',
    module:     'import-data',
    routes:     [
      {
        title:     'Импорт данных о валидациях проездных билетов',
        path:      '/import-data/tickets-validation',
        component: TicketsValidation,
        section:   'tickets-validation',
      },
    ],
  },
  {
    groupTitle: 'Удаленное обновление',
    module:     'mnt-configuration',
    routes:     [
      {
        title:     'Конфигурации МНТ',
        path:      '/mnt-configuration/configurations',
        component: ConfigurationsMNT,
        section:   'configurations',
      },
      {
        path:      '/mnt-configuration/configuration/:group_id',
        component: ConfigurationGroup,
        section:   'configuration',
      },
      {
        title:     'Состояние ТС',
        path:      '/mnt-configuration/vehicle-groups',
        component: VehicleGroups,
        section:   'vehicle-groups',
      },
    ],
  },
  {
    module: 'vehicle-work-data',
    routes: [
      { title: 'Сведения о выпуске', path: '/vehicle-work-data', component: VehicleWorkData },
    ],
  },
  {
    groupTitle: 'Мониторинг бортового оборудования',
    module:     'vehicle-diagnostic',
    routes:     [
      {
        title:     'Текущее состояние БО',
        path:      '/vehicle-diagnostic/current',
        section:   'current',
        component: VehicleDiagnostic,
      },
      {
        title:     'Анализ работы АСМПП',
        path:      '/vehicle-diagnostic/asmpp',
        section:   'asmpp',
        component: Asmpp,
      },
      {
        title:     'Анализ работоспособности оборудования СМСВ',
        path:      '/vehicle-diagnostic/eqnt-perf-analysis-smsv',
        section:   'eqnt-perf-analysis-smsv',
        component: EquipmentAnalysisPerfSmsv,
      },
      {
        title:     'Анализ температурного режима в ТС',
        path:      '/vehicle-diagnostic/temperature-sensors-analysis',
        section:   'temperature-sensors-analysis',
        component: TemperatureSensorsAnalysis,
      }
    ],
  },
  {
    groupTitle: 'ПДМ',
    module:     'pdm',
    routes:     [
      {
        title:     'Тепловая карта',
        path:      '/pdm/heatmap',
        component: Heatmap,
        section:   'heatmap',
      },
      {
        title:     'Редактор уникальных деревьев датчиков',
        path:      '/pdm/tree-editor',
        component: TreeEditor,
        section:   'tree-editor',
      },
      {
        title:     'Мониторинг состояния БО',
        path:      '/pdm/vehicle-diagnostic-report',
        component: VehicleDiagnosticReport,
        section:   'vehicle-diagnostic-report',
      },
      {
        title:     'Журнал изменений состояния узла',
        path:      '/pdm/change-node-journal',
        component: ChangeNodeJournal,
        section:   'change-node-journal',
      },
      {
        title:     'Графические отчёты',
        path:      '/pdm/charts',
        component: Charts,
        section:   'charts',
      },
      {
        title:     'Сервисный отчет',
        path:      '/pdm/service',
        component: Service,
        section:   'service',
      },
      {
        title:     'Отчёт о состоянии БО за период',
        path:      '/pdm/equipment-status-report',
        component: EquipmentStatusReport,
        section:   'equipment-status-report',
      },
      {
        title:     'Менеджер импорта отчётов',
        path:      '/pdm/import-manager',
        component: ImportManager,
        section:   'import-manager',
      },
    ],
  },
  {
    groupTitle: 'Отчеты ИСПВ',
    module:     'adas',
    routes:     [
      {
        title:     'Количество и динамика инцидентов',
        path:      '/adas/incidents-dynamic',
        component: IncidentsDynamic,
        section:   'incidents-dynamic',
      },
      {
        title:     'Распределение инцидентов по маршруту',
        path:      '/adas/incidents-distribution',
        component: IncidentsDistribution,
        section:   'incidents-distribution',
      },
      {
        title:     'Детализация инцидентов по ТС',
        path:      '/adas/incidents-detailing',
        component: IncidentsDetailing,
        section:   'incidents-detailing',
      },
    ],
  },
  {
    module: 'smsv',
    routes: [
      { title: 'Система мониторинга состояния водителя', path: '/smsv', component: SMSV },
    ],
  },
  {
    module: 'driving-assessment',
    routes: [
      { title: 'Оценка вождения', path: '/driving-assessment', component: DrivingAssessment },
    ],
  },
  {
    groupTitle: 'Настройки системы',
    module:     'system',
    routes:     [
      {
        title:     'Подсистема навигации',
        path:      '/system/navigation',
        component: NavigationSettings,
        section:   'navigation',
      },
      {
        title:     'Подсистема доступа к видео',
        path:      '/system/video',
        component: SystemVideoSettings,
        section:   'video',
      },
      {
        title:     'Подсистема анализа пассажиропотока',
        path:      '/system/passengers',
        component: PassengersSettings,
        section:   'passengers',
      },
      {
        title:     'Подсистема журналирования',
        path:      '/system/journals',
        component: JournalsSettings,
        section:   'journals',
      },
      {
        title:     'Подсистема ПБК',
        path:      '/system/bc',
        component: BCSettings,
        section:   'bc',
      },
      {
        title:     'Настройка параметров импорта данных из ВИС',
        path:      '/system/eis',
        component: EIS,
        section:   'eis',
      },
      {
        title:     'Датчики температуры',
        path:      '/system/temperatureSensors',
        component: TemperatureSensors,
        section:   'temperatureSensors',
      },
      {
        title:     'Настройки мониторинга тревожной сигнализации',
        path:      '/system/alarmSystem',
        component: AlarmSystem,
        section:   'alarmSystem',
      },
      {
        title:     'Система мониторинга состояния водителя',
        path:      '/system/smsv',
        component: SMSVSettings,
        section:   'smsv',
      },
    ],
  },
  {
    groupTitle: 'Справочники',
    module:     'handbooks',
    routes:     [
      { path: '/handbooks/table/:handbookType', component: SpreadSheetHandbook },
    ],
  },
  {
    module:     'journal',
    routes:     [
      {
        title: 'Журналы',
        path: '/journal',
        component: Journal,
      }
    ],
  },
  {
    groupTitle: 'Администрирование',
    module:     'admin',
    routes:     [
      { title: 'Пользователи', path: '/users', component: Users, section: 'users' },
      { title: 'Роли', path: '/roles', component: Roles, section: 'roles' },
    ],
  },
  {
    routes: [
      { title: 'О платформе', path: '/about', component: About, alwaysAvailable: true },
    ],
  },
];

const getSectionName = (module: string | undefined | null, section: string | undefined | null) => {
  if (module) {
    return `${module}/${section}`;
  }
  return section;
};

const reduceSection = (module?: string) => {
  return (routes: IRoute[], route: IRoute) => {
    if ('section' in route) {
      const isRouteEnable = checkModule(getSectionName(module, route.section));
      if (isRouteEnable) {
        const reducedSection = { path: route.path, component: route.component, title: route.title } as IRoute;
        if (route.alwaysAvailable) {
          reducedSection.alwaysAvailable = route.alwaysAvailable;
        }
        return [...routes, reducedSection];
      } else {
        return routes;
      }
    }
    const reducedSection = { path: route.path, component: route.component, title: route.title } as IRoute;
    if (route.alwaysAvailable) {
      reducedSection.alwaysAvailable = route.alwaysAvailable;
    }
    return [...routes, reducedSection];
  };
};

export const routes = routesList.reduce((routes: IRoute[], group: IRouteGroup) => {
  if ('module' in group) {
    const isModuleEnable = checkModule(group.module);
    if (isModuleEnable) {
      const moduleRoutes: IRoute[] = group.routes.reduce(reduceSection(group.module), []);
      return [...routes, ...moduleRoutes];
    } else {
      return routes;
    }
  } else {
    const moduleRoutes: IRoute[] = group.routes.reduce(reduceSection(), []);
    return [...routes, ...moduleRoutes];
  }
}, []);

export interface ILink {
  key?: string;
  name: string;
  url?: string;
  links?: ILink[];
  isExpanded?: boolean;
  alwaysAvailable?: boolean;
  off?: string[];
  module?: string;
  section?: string;
}

const getLink = (route: IRoute, group?: IRouteGroup): ILink => {
  let link: ILink = {
    name: route.title || '',
    url:  route.path,
  };
  if (group && group.module) {
    link.module = group.module;
  }
  if (route.section) {
    link.section = route.section;
  }
  if (route.off) {
    link.off = route.off;
  }
  if (route.alwaysAvailable) {
    link.alwaysAvailable = route.alwaysAvailable;
  }
  return link;
};

const reduceMenuSections = (group?: IRouteGroup) => {
  return ((allLinks: ILink[], route: IRoute) => {
    if (route.section) {
      const isRouteEnable = checkModule(getSectionName((group || {}).module, route.section));
      if (isRouteEnable) {
        if (route.title) {
          return [...allLinks, getLink(route, group)];
        } else {
          return allLinks;
        }
      } else {
        return allLinks;
      }
    }
    if (route.title) {
      return [...allLinks, getLink(route, group)];
    } else {
      return allLinks;
    }
  })
};

export const menuItems: ILink[] = routesList.reduce((allLinks: ILink[], group: IRouteGroup) => {
  if (group.groupTitle) {
    if (group.module) {
      const isModuleEnable = checkModule(group.module)
      if (isModuleEnable) {
        if (group.module === 'handbooks') {
          const data: any = Object.keys(handbooks)
                                  .map((key: string) => ({
                                    title:   handbooks[key].title,
                                    path:    `/handbooks/table/${key}`,
                                    section: key,
                                  }));
          const links: ILink[] = data.reduce(reduceMenuSections(group), []);
          if (links.length > 0) {
            let linksGroup: ILink = {
              name:   group.groupTitle,
              module: group.module,
              links,
            };
            return [...allLinks, linksGroup];
          } else {
            return allLinks;
          }
        }
        const links: ILink[] = group.routes.reduce(reduceMenuSections(group), []);
        if (links.length > 0) {
          let linksGroup: ILink = {
            name:   group.groupTitle,
            module: group.module,
            links,
          };
          return [...allLinks, linksGroup];
        } else {
          return allLinks;
        }
      } else {
        return allLinks;
      }
    } else {
      const links: ILink[] = group.routes.reduce(reduceMenuSections(group), []);
      if (links.length > 0) {
        let linksGroup: ILink = {
          name: group.groupTitle,
          links,
        }
        return [...allLinks, linksGroup];
      } else {
        return allLinks;
      }
    }
  } else {
    if (group.module) {
      const isModuleEnable = checkModule(group.module);
      if (isModuleEnable) {
        const links: ILink[] = group.routes.reduce(reduceMenuSections((group || undefined)), []);
        return [...allLinks, ...links];
      } else {
        return allLinks;
      }
    } else {
      const links: ILink[] = group.routes.reduce(reduceMenuSections(), []);
      return [...allLinks, ...links];
    }
  }
}, []);
